import React from "react";
import { AlertTriangle, ShieldAlert, Waves, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function TsunamiBanner({ quake, onDismiss }) {
  return (
    <AnimatePresence>
      {quake && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="relative z-40 border-y border-red-500/40 bg-red-950/90 backdrop-blur-md"
          data-testid="tsunami-banner"
        >
          <div className="mx-auto flex max-w-full items-center gap-4 px-4 py-2.5">
            <div className="flex items-center gap-2">
              <ShieldAlert className="h-5 w-5 text-red-300 animate-pulse" />
              <Waves className="h-5 w-5 text-red-200" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-red-200">
                <AlertTriangle className="h-3.5 w-3.5" /> Peringatan Dini Tsunami
              </div>
              <div className="truncate text-sm text-red-50">
                <span className="font-mono font-bold">M {quake.magnitude?.toFixed(1)}</span>
                {" — "}
                {quake.location}
                {quake.tsunami && typeof quake.tsunami === "string" && ` · ${quake.tsunami}`}
              </div>
            </div>
            <button
              onClick={onDismiss}
              className="rounded-full p-1.5 text-red-200 hover:bg-red-900/50"
              aria-label="Dismiss"
              data-testid="tsunami-banner-dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
